// src/constants/collectionMap
// Map of Firestore collection keys to the user-friendly city/town names.
export const COLLECTION_MAP = {
  andover: "Andover",
  ansonia: "Ansonia",
  ashford : "Ashford",
  bethlehem: "Bethlehem",
  bethany : "Bethany",
  bloomfield: "Bloomfield",
  bolton: "Bolton",
  bozrah : "Bozrah",
  branford: "Branford",
  bridgeport: "Bridgeport",
  bridgewater: "Bridgewater",
  bristol: "Bristol",
  brookfield: "Brookfield",
  brooklyn: "Brooklyn",
  burlington : "Burlington",
  canaan: "Canaan",
  canterbury: "Canterbury",
  canton: "Canton",
  chaplin: "Chaplin",
  cheshire : "Cheshire",
  chester : "Chester",
  clinton: "Clinton",
  colebrook: "Colebrook",
  columbia : "Columbia",
  cornwall: "Cornwall",
  coventry: "Coventry",
  danbury : "Danbury",
  deepriver: "Deep River",
  eastgranby: "East Granby",
  eastHaven : "East Haven",
  easthaddam: "East Haddam",
  eastlyme: "East Lyme",
  eastford : "Eastford",
  easton : "Easton",
  eastwindsor: "East Windsor",
  ellington : "Ellington",
  enfield : "Enfield",
  essex: "Essex",
  farmington : "Farmington",
  fairfield: "Fairfield",
  franklin : "Franklin",
  glastonbury: "Glastonbury",
  granby: "Granby",
  griswold: "Griswold",
  guilford : "Guilford",
  haddam : "Haddam",
  hamden: "Hamden",
  hampton: "Hampton",
  harwinton: "Harwinton",
  hebron : "Hebron",
  lebanon: "Lebanon",
  kent: "Kent",
  killingly : "Killingly",
  killingworth : "Killingworth",
  lisbon: "Lisbon",
  lyme: "Lyme",
  madison: "Madison",
  marlborough : "Marlborough",
  manchester: "Manchester",
  mansfield: "Mansfield",
  middlefield: "Middlefield",
  middletown: "Middletown",
  milford: "Milford",
  monroe: "Monroe",
  montville : "Montville", 
  naugatuck : "Naugatuck", 
  newbritain: "New Britain",
  newcanaan : "New Canaan",
  newfairfield: "New Fairfield",
  newhartford: "New Hartford",
  newhaven: "New Haven",
  newlondon: "New London",
  newmilford: "New Milford",
  newtown: "Newtown",
  newington : "Newington",
  norfolk : "Norfolk", 
  "north canaan" : "North Cannan",
  northbranford: "North Branford",
  "north haven" : "North Haven",
  "north stonington" : "North Stonington",
  norwalk: "Norwalk",
  norwich: "Norwich",
  oldlyme: "Old Lyme",
  oldsaybrook: "Old Saybrook",
  orange: "Orange",
  oxford : "Oxford",
  plainfield: "Plainfield",
  plainville : "Plainville",
  plymouth : "Plymouth",
  prospect : "Prospect",
  pomfret: "Pomfret",
  preston: "Preston",
  redding: "Redding",
  ridgefield : "Ridgefield",
  "rocky hill" : "Rocky Hill",
  roxbury : "Roxbury",
  salem: "Salem",
  salisbury: "Salisbury",
  scotland : "Scotland",
  simsbury : "Simsbury",
  seymour : "Seymour",
  sharon: "Sharon",
  shelton: "Shelton",
  somers: "Somers",
  southwindsor: "South Windsor",
  southbury: "Southbury",
  sprague: "Sprague",
  stafford: "Stafford",
  stamford: "Stamford",
  sterling: "Sterling",
  stonington: "Stonington",
  stratford: "Stratford",
  thompson: "Thompson",
  tolland: "Tolland",
  torrington : "Torrington",
  trumbull: "Trumbull",
  union: "Union",
  voluntown : "Voluntown",
  wallingford: "Wallingford",
  warren : "Warren",
  waterbury : "Waterbury",
  waterford: "Waterford",
  watertown : "Watertown",
  westbrook: "Westbrook",
  westhartford: "West Hartford",
  westhaven: "West Haven",
  westport: "Westport",
  weston : "Weston",
  willington: "Willington",
  winchester: "Winchester",
  windsorLocks : "Windsor Locks",
  windham: "Windham",
  wilton : "Wilton",
  wolcott: "Wolcott",
  woodstock: "Woodstock",
};

export const TOWN_TO_HUD_AREA_MAP = {
  andover: "Hartford-West Hartford-East Hartford",
  ansonia: "New Haven-Meriden",
  ashford: "Windham County",
  bethlehem: "Litchfield County",
  bethany: "New Haven-Meriden",
  bloomfield: "Hartford-West Hartford-East Hartford",
  bolton: "Hartford-West Hartford-East Hartford",
  bozrah: "Norwich-New London",
  branford: "New Haven-Meriden",
  bridgeport: "Bridgeport",
  bridgewater: "Litchfield County",
  bristol: "Hartford-West Hartford-East Hartford",
  brookfield: "Danbury",
  burlington: "Hartford-West Hartford-East Hartford",
  brooklyn: "Windham County",
  canaan: "Litchfield County",
  canterbury: "Windham County",
  canton: "Hartford-West Hartford-East Hartford",
  chaplin: "Windham County",
  cheshire: "New Haven-Meriden",
  chester: "Southern Middlesex County",
  clinton: "Southern Middlesex County",
  colebrook: "Litchfield County",
  columbia: "Hartford-West Hartford-East Hartford",
  cornwall: "Litchfield County",
  coventry: "Hartford-West Hartford-East Hartford",
  danbury: "Danbury",
  deepriver: "Southern Middlesex County",
  eastgranby: "Hartford-West Hartford-East Hartford",
  easthaddam: "Southern Middlesex County",
  eastlyme: "Norwich-New London",
  eastford: "Windham County",
  easton: "Bridgeport",
  eastwindsor: "Hartford-West Hartford-East Hartford",
  ellington: "Hartford-West Hartford-East Hartford",
  essex: "Southern Middlesex County",
  farmington: "Hartford-West Hartford-East Hartford",
  fairfield: "Bridgeport",
  franklin: "Norwich-New London",
  glastonbury: "Hartford-West Hartford-East Hartford",
  granby: "Hartford-West Hartford-East Hartford",
  griswold: "Norwich-New London",
  guilford: "New Haven-Meriden",
  haddam : "Hartford-West Hartford-East Hartford",
  hamden: "New Haven-Meriden",
  hampton: "Windham County",
  harwinton: "Litchfield County",
  hebron: "Hartford-West Hartford-East Hartford",
  lebanon: "Norwich-New London",
  kent: "Litchfield County",
  killingly: "Windham County",
  killingworth: "Southern Middlesex County",
  lisbon: "Norwich-New London",
  lyme: "Southern Middlesex County",
  madison: "New Haven-Meriden",
  marlborough: "Hartford-West Hartford-East Hartford",
  manchester: "Hartford-West Hartford-East Hartford",
  mansfield: "Windham County",
  middlefield: "New Haven-Meriden",
  middletown: "New Haven-Meriden",
  milford: "Milford-Ansonia-Seymour",
  monroe: "Bridgeport",
  naugatuck: "Waterbury",
  newbritain: "Hartford-West Hartford-East Hartford",
  newfairfield: "Danbury",
  newhartford: "Litchfield County",
  newhaven: "New Haven-Meriden",
  newlondon: "Norwich-New London",
  newmilford: "Litchfield County",
  newtown: "Danbury",
  newington: "Hartford-West Hartford-East Hartford",
  montville: "Norwich-New London",
  norfolk: "Litchfield County",
  "north canaan" : "Litchfield County",
  northbranford: "New Haven-Meriden",
  "north haven": "New Haven-Meriden",
  "north stonington" : "Norwich-New London",
  norwalk: "Stamford-Norwalk",
  norwich: "Norwich-New London",
  oldlyme: "Southern Middlesex County",
  oldsaybrook: "Southern Middlesex County",
  orange: "Milford-Ansonia-Seymour",
  oxford: "Waterbury",
  plainfield: "Windham County",
  plainville: "Hartford-West Hartford-East Hartford",
  plymouth: "Litchfield County",
  prospect: "Waterbury",
  pomfret: "Windham County",
  preston: "Norwich-New London",
  redding: "Danbury",
  ridgefield: "Danbury",
  "rocky hill" : "Hartford-West Hartford-East Hartford",
  roxbury: "Litchfield County",
  salem: "Norwich-New London",
  salisbury: "Litchfield County",
  scotland: "Windham County",
  sharon: "Litchfield County",
  shelton: "Bridgeport",
  seymour: "New Haven-Meriden",
  somers: "Hartford-West Hartford-East Hartford",
  southwindsor: "Hartford-West Hartford-East Hartford",
  southbury: "Waterbury",
  southington: "Hartford-West Hartford-East Hartford",
  sprague: "Norwich-New London",
  stafford: "Hartford-West Hartford-East Hartford",
  stamford: "Stamford-Norwalk",
  sterling: "Windham County",
  stonington: "Norwich-New London",
  stratford: "Bridgeport",
  thompson: "Windham County",
  tolland: "Hartford-West Hartford-East Hartford",
  trumbull: "Bridgeport",
  union: "Hartford-West Hartford-East Hartford",
  wallingford: "New Haven-Meriden",
  waterford: "Norwich-New London",
  westbrook: "Southern Middlesex County",
  westhartford: "Hartford-West Hartford-East Hartford",
  westhaven: "New Haven-Meriden",
  westport: "Bridgeport",
  willington: "Windham County",
  winchester: "Litchfield County",
  windham: "Windham County",
  wolcott: "Waterbury",
  woodstock: "Windham County",
  enfield: "Hartford-West Hartford-East Hartford", 
  middlebury: "Waterbury",
  torrington: "Litchfield County",
  warren: "Litchfield County",
  voluntown: "Norwich-New London",
  washington: "Litchfield County",
  weston: "Bridgeport",
  wilton: "Bridgeport",
  windsorLocks : "Hartford-West Hartford-East Hartford",
  woodbridge: "New Haven-Meriden",
  woodbury: "Litchfield County"
};

export const ALL_TOWNS = [
"Andover",
"Ansonia",
"Ashford",
"Avon",
"Barkhamsted",
"Beacon Falls",
"Berlin",
"Bethany",
"Bethel",
"Bethlehem",
"Bloomfield",
"Bolton",
"Bozrah",
"Branford",
"Bridgeport",
"Bridgewater",
"Bristol",
"Brookfield",
"Brooklyn",
"Burlington",
"Canaan",
"Canterbury",
"Canton",
"Chaplin",
"Cheshire",
"Chester",
"Clinton",
"Colchester",
"Colebrook",
"Columbia",
"Cornwall",
"Coventry",
"Cromwell",
"Danbury",
"Darien",
"Deep River",
"Derby",
"Durham",
"East Granby",
"East Haddam",
"East Hampton",
"East Hartford",
"East Haven",
"East Lyme",
"East Windsor",
"Eastford",
"Easton",
"Ellington",
"Enfield",
"Essex",
"Fairfield",
"Farmington",
"Franklin",
"Glastonbury",
"Goshen",
"Granby",
"Greenwich",
"Griswold",
"Groton",
"Guilford",
"Haddam",
"Hamden",
"Hampton",
"Hartford",
"Hartland",
"Harwinton",
"Hebron",
"Kent",
"Killingly",
"Killingworth",
"Lebanon",
"Ledyard",
"Lisbon",
"Litchfield",
"Lyme",
"Madison",
"Manchester",
"Mansfield",
"Marlborough",
"Meriden",
"Middlebury",
"Middlefield",
"Middletown",
"Milford",
"Monroe",
"Montville",
"Morris",
"Naugatuck",
"Newington",
"Newtown",
"New Britain",
"New Canaan",
"New Fairfield",
"New Hartford",
"New Haven",
"New London",
"New Milford",
"Norfolk",
"North Branford",
"North Canaan",
"North Haven",
"North Stonington",
"Norwalk",
"Norwich",
"Old Lyme",
"Old Saybrook",
"Orange",
"Oxford",
"Plainfield",
"Plainville",
"Plymouth",
"Pomfret",
"Portland",
"Preston",
"Prospect",
"Putnam",
"Redding",
"Ridgefield",
"Rocky Hill",
"Roxbury",
"Salem",
"Salisbury",
"Scotland",
"Seymour",
"Sharon",
"Shelton",
"Sherman",
"Simsbury",
"Somers",
"South Windsor",
"Southbury",
"Southington",
"Sprague",
"Stafford",
"Stamford",
"Sterling",
"Stonington",
"Stratford",
"Suffield",
"Thomaston",
"Thompson",
"Tolland",
"Torrington",
"Trumbull",
"Union",
"Vernon",
"Voluntown",
"Wallingford",
"Warren",
"Washington",
"Waterbury",
"Waterford",
"Watertown",
"West Hartford",
"West Haven",
"Westbrook",
"Weston",
"Westport",
"Wethersfield",
"Willington",
"Wilton",
"Winchester",
"Windham",
"Windsor",
"Windsor Locks",
"Wolcott",
"Woodbridge",
"Woodbury",
"Woodstock"
];

export const PROPERTY_TOWNS = [
  "Ansonia",
  "Ashford",
  "Bethany",
  "Bozrah",
  "Cheshire",
  "Chester",
  "Columbia",
  "Danbury",
  "Eastford",
  "East Haven",
  "Easton",
  "Ellington",
  "Farmington",
  "Franklin",
  "Guilford",
  "Haddam",
  "Hebron",
  "Killingly",
  "Killingworth",
  "Marlborough",
  "Montville",
  "Naugatuck",
  "New Canaan",
  "Newington",
  "Norfolk",
  "North Canaan",
  "North Haven",
  "North Stonington",
  "Oxford",
  "Plainville",
  "Plymouth",
  "Prospect",
  "Ridgefield",
  "Rocky hill",
  "Roxbury",
  "Scotland",
  "Shelton",
  "Simsbury",
  "Seymour",
  "Torrington",
  "Voluntown",
  "Warren",
  "Washington",
  "Waterbury",
  "Watertown",
  "Weston",
  "Wilton",
  "Windsor Locks",
  "Woodbridge",
  "Woodbury",
]

export const VISION_TOWNS = [
  "Andover",
  "Bethlehem",
  "Bloomfield",
  "Bolton",
  "Branford",
  "Bridgeport",
  "Bridgewater",
  "Bristol",
  "Brookfield",
  "Brooklyn",
  "Burlington",
  "Canaan",
  "Canterbury",
  "Canton",
  "Chaplin",
  "Clinton",
  "Colebrook",
  "Cornwall",
  "Coventry",
  "Deep River",
  "East Granby",
  "East Haddam",
  "East Lyme",
  "East Windsor",
  "Enfield",
  "Essex",
  "Fairfield",
  "Glastonbury",
  "Granby",
  "Griswold",
  "Hamden",
  "Hampton",
  "Harwinton",
  "Lebanon",
  "Kent",
  "Lisbon",
  "Lyme",
  "Madison",
  "Manchester",
  "Mansfield",
  "Middlebury",
  "Middlefield",
  "Middletown",
  "Milford",
  "Monroe",
  "New Britain",
  "New Fairfield",
  "New Hartford",
  "New Haven",
  "New London",
  "New Milford",
  "Newtown",
  "North Branford",
  "Norwalk",
  "Norwich",
  "Old Lyme",
  "Old Saybrook",
  "Orange",
  "Plainfield",
  "Pomfret",
  "Preston",
  "Redding",
  "Salem",
  "Salisbury",
  "Sharon",
  "Somers",
  "South Windsor",
  "Southbury",
  "Southington",
  "Sprague",
  "Stafford",
  "Stamford",
  "Sterling",
  "Stonington",
  "Stratford",
  "Thompson",
  "Tolland",
  "Trumbull",
  "Union",
  "Wallingford",
  "Waterford",
  "Westbrook",
  "West Hartford",
  "West Haven",
  "Westport",
  "Willington",
  "Winchester",
  "Windham",
  "Wolcott",
  "Woodstock"
];

export const labelMap = {
  Description: "description",
  "Use Code": "useCode",
  Zone: "zone",
  Acres: "acres",
  "Year Built": "yearBuilt",
  "Living Area (sqft)": "livingArea",
  MBLU: "MBLU",
  PID: "pid",
  "Account #": "acctNum",
  "Lot #": "devLot",
  Latitude: "lat",
  Longitude: "lng",
  Owner: "owner",
  "Co-Owner": "MainContent_lblCoOwner",
  "Mailing Address": "MainContent_lblAddr1",
  "Sale Price": "salePrice",
  "Appraised Value": "appraisedValue",
  "Assessed Value": "assessedValue",
  "Appraisal (Improvements)": "appraisalImprovements",
  "Appraisal (Land)": "appraisalLand",
  "Book/Page": "bookPage",
  Instrument: "instrument",
  "Total Bathrooms": "Total Bthrms",
};

export const ownershipHistoryColumns = [
  { key: "owner", label: "Owner" },
  { key: "salePrice", label: "Sale Price" },
  { key: "saleDate", label: "Sale Date" },
  { key: "bookPage", label: "Book/Page" },
  { key: "instrument", label: "Instrument" },
];

// Derived array of all collection keys (sorted)
export const COLLECTIONS = Object.keys(COLLECTION_MAP).sort();